import { render, staticRenderFns } from "./jessibucaBack.vue?vue&type=template&id=01da520b&scoped=true&"
import script from "./jessibucaBack.vue?vue&type=script&lang=js&"
export * from "./jessibucaBack.vue?vue&type=script&lang=js&"
import style0 from "./jessibucaBack.vue?vue&type=style&index=0&id=01da520b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01da520b",
  null
  
)

export default component.exports